<template>
  <div v-if="buyTogether" class="products-buy-together">
    <ProductsSlider
      :products="buyTogether.data"
      :filter-data="buyTogether.filter_data"
      :title="title"
      :title-analytics="isInCart ? 'Разом з цим купують (кошик)' : 'Разом з цим купують'"
      :is-toggle="isToggleSliderShow"
      :simple-product-card="simpleProductCard"
      :without-container="withoutContainer"
      :slider-space-between="sliderSpaceBetween"
      :slider-per-view="sliderPerView"
      :slider-breakpoints="sliderBreakpoints"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ProductsSlider from './ProductsSlider'

export default {
  name: 'ProductsBuyTogether',
  components: {
    ProductsSlider
  },
  data () {
    return {
      buyTogether: null
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    productId: {
      type: [String, Number],
      default: ''
    },
    productIdList: {
      type: Array,
      default: () => []
    },
    isToggleSliderShow: {
      type: Boolean,
      default: false
    },
    isInCart: {
      type: Boolean,
      default: false
    },
    simpleProductCard: {
      type: Boolean,
      default: false
    },
    withoutContainer: {
      type: Boolean,
      default: false
    },
    sliderSpaceBetween: {
      type: Number,
      default: 0
    },
    sliderPerView: {
      type: Number,
      default: 1.5
    },
    sliderBreakpoints: {
      type: Object,
      default: () => ({
        319: {
          slidesPerView: 1
        },
        359: {
          slidesPerView: 2
        },
        550: {
          slidesPerView: 3
        },
        1023: {
          slidesPerView: 4
        },
        1299: {
          slidesPerView: 5
        }
      })
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  },
  watch: {
    productIdList () {
      this.getBuyTogetherProducts()
    }
  },
  methods: {
    getBuyTogetherProducts () {
      const params = {}

      if (this.productId) params.product_id = this.productId
      if (this.productIdList.length) params.product_id_list = this.productIdList

      axios
        .post(this.urlLanguagePrefix + '/shop/catalog/get-buy-together/', params)
        .then(res => {
          if (res.data?.success) {
            this.buyTogether = res.data
          }
        })
    }
  },
  mounted () {
    if (this.data) {
      this.buyTogether = this.data
    } else {
      this.getBuyTogetherProducts()
    }
  }
}
</script>

<style lang="sass">
.products-buy-together
  .swiper-container
    +mmax(550)
      padding: 0
</style>
